import { CalendarDate } from '@internationalized/date';

export const isBeforeCutoff = (
  cutoff: CalendarDate,
  date: CalendarDate | null
) => date !== null && cutoff.compare(date) > 0;
